<template>
    <div class="is-inline-block">
      <div class="is-inline-block">
        <div class="quick-action">
          <button type="button" class="button" @click="updateIdentityVerificationModalState(true)" title="Click to send out vehicle verification to supplier.">
            <i class="icon fal fa-credit-card-front fa-lg" />
          </button>
        </div>
      </div>
      <portal to="global-modal-portal">
        <b-modal :active.sync="isIdentityVerification" scroll="keep" :has-modal-card="true">
          <div class="modal-card" style="width: auto">
            <header class="modal-card-head">
              <div class="subtitle is-6 has-text-centered has-text-info is-marginless">Send Identity Verification to Supplier</div>
            </header>
            <section class="modal-card-body view-container" style="padding: 12px; width: 769px !important;">
              <error-display-component :serverErrors="serverErrors" :serverErrorMessage="serverErrorMessage"></error-display-component>
              <div class="columns">
                <div class="column is-12">
                  <form data-vv-scope="recipient-form">
                    <div class="field">
                      <label class="label">Recipients<b-icon pack="fas" icon="star" class="fa-ss"></b-icon></label>
                      <multiselect
                        :multiple="true"
                        :taggable="true"
                        v-validate="{'required': true}"
                        data-vv-scope="recipient-form"
                        data-vv-as="recipient"
                        data-vv-validate-on="input|close"
                        :class="{'is-danger': errors.has('recipient-form.recipients') }"
                        @tag="onRecipientAdded"
                        name="recipients"
                        label="name"
                        trackBy="email"
                        tagPlaceholder="Enter to add email address"
                        v-model="selectedRecipients"
                        :options="selectedRecipients"
                        :disabled="true">
                      </multiselect>
                      <span v-show="errors.has('recipient-form.recipients')" class="help is-danger"><i v-show="errors.has('recipient-form.recipients')" class="fas fa-exclamation-triangle"></i> {{ errors.first('recipient-form.recipients') }}</span>
                    </div>
                  </form>
                </div>
              </div>
              <div class="columns">
                <div class="column is-12 field">
                  <a class="is-link is-pulled-right" @click="onEditSupplier(currentDeal.purchaserId)">
                    {{currentDeal.purchaserContactName !== '' ? currentDeal.purchaserContactName : currentDeal.purchaserName}}
                  </a>
                </div>
              </div>
              <div class="columns">
                <div class="column is-12">
                  <div class="field">
                    <label class="label">Subject</label>
                    <div class="control">
                      <input name="overridingSubject" data-vv-as="overridingSubject" :class="{'input': true }" type="text" v-model="overridingSubject">
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns">
                <div class="column is-12">
                  <div class="field">
                    <label class="label">Message (optional)</label>
                    <div class="control">
                      <textarea name="optionalMessage" :class="{'textarea': true}" data-vv-as="optional message" v-model="optionalMessage"></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <footer class="modal-card-foot">
              <div class="columns" style="width: 100%">
                <div class="column is-12">
                  <button class="button is-primary" :class="{'is-loading': isSaving }" @click="onEmailIdentityVerification(currentDeal)" type="button">Send</button>
                  <button class="button is-danger" @click="updateIdentityVerificationModalState(false)" type="button">Cancel</button>
                </div>
              </div>
            </footer>
          </div>
        </b-modal>
      </portal>

      <portal to="global-modal-portal" v-if="editSupplierActive">
        <b-modal :active.sync="editSupplierActive" scroll="keep" :has-modal-card="true" id="edit-customer-modal">
          <div class="modal-card">
            <header class="modal-card-head">
              <p class="modal-card-title"><portal-target name="modal-header" slim/></p>
            </header>
            <section class="modal-card-body">
              <edit-supplier :supplierId="editSupplierId" mode="modal" actionPortal="modal-footer" headerPortal="modal-header" v-on:on-save="onSupplierSaved" v-on:on-cancel="onSupplierCancelled"></edit-supplier>
            </section>
            <footer class="modal-card-foot">
              <portal-target name="modal-footer" class="actions" slim/>
          </footer>
          </div>
        </b-modal>
      </portal>

    </div>
</template>

<script>
import supplierService from '@/services/supplierService'
import validateBeforeSubmitMixin from '@/mixins/generic/validateBeforeSubmit'
import ErrorDisplayComponent from '@/components/generic/ErrorDisplayComponent'
import EditSupplier from '@/components/configuration/suppliers/EditSupplier'

import { createNamespacedHelpers } from 'vuex'
const mapUserGetters = createNamespacedHelpers('user').mapGetters
const mapDealerState = createNamespacedHelpers('dealer').mapState

export default {
  name: 'DealSupplierIdentityVerificationAction',
  mixins: [validateBeforeSubmitMixin],
  components: {
    'error-display-component': ErrorDisplayComponent,
    'edit-supplier': EditSupplier
  },
  props: {
    currentDeal: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isIdentityVerification: false,
      instanceId: this.$uuid.v4(),
      selectedRecipients: [],
      optionalMessage: '',
      overridingSubject: '',
      isSaving: false,
      serverErrors: [],
      serverErrorMessage: '',
      editSupplierActive: false,
      editSupplierId: 0
    }
  },
  computed: {
    ...mapUserGetters(['currentUser']),
    ...mapDealerState(['currentDealer'])
  },
  methods: {
    onRecipientAdded: function (data) {
      var recipient = {
        name: data,
        email: data
      }

      this.selectedRecipients.push(recipient)
    },
    clearAllRecipients: function () {
      this.optionalMessage = ''
      this.overridingSubject = ''
      this.selectedRecipients = []
      this.editSupplierId = 0
    },
    updateIdentityVerificationModalState: function (state) {
      this.isIdentityVerification = state

      if (this.currentDeal.purchaserId !== null) {
        if (state === true) {
          this.overridingSubject = 'Identity Verification - Your details are required to complete the identity verification process.'
          this.optionalMessage = 'Please navigate to our secure webpage to complete your identity verification.'
          this.selectedRecipients = []

          if (this.currentDeal && (this.currentDeal.purchaserContactEmail !== '' || this.currentDeal.purchaserContactMobile !== '')) {
            let proposedName = this.currentDeal.purchaserContactName !== '' ? this.currentDeal.purchaserContactName : this.currentDeal.purchaserName
            var data = {
              id: this.currentDeal.purchaserId,
              mobile: this.currentDeal.purchaserContactMobile,
              email: this.currentDeal.purchaserContactEmail,
              name: proposedName + '(' + this.currentDeal.purchaserContactEmail + '  ' + this.currentDeal.purchaserContactMobile + ')'
            }
            this.selectedRecipients.push(data)
          }
        }
      }

      if (state === false) {
        this.clearAllRecipients()
      }
    },
    onEmailIdentityVerification: function (deal) {
      var emailAddresses = this.selectedRecipients.map(e => e.email).join(', ')
      let mobile = (this.selectedRecipients[0].mobile) ? this.selectedRecipients[0].mobile : ''
      var supplierIdentityVerificationRequestModel = {
        supplierId: deal.purchaserId,
        userId: this.currentUser.id,
        dealerId: this.currentDealer.id,
        toEmailAddress: emailAddresses,
        subject: this.overridingSubject,
        content: this.optionalMessage,
        mobile: mobile
      }

      this.isSaving = true
      this.serverErrorMessage = ''
      this.serverErrors = []
      supplierService.createIdentityVerificationRequest(supplierIdentityVerificationRequestModel).then(response => {
        this.isSaving = false
        if (response.errors) {
          this.serverErrors = response.errors
        } else {
          this.clearAllRecipients()
          this.isIdentityVerification = false
        }
      }).catch((error) => {
        this.isSaving = false
        this.serverErrorMessage = error.message
      })
    },
    onSupplierSaved: function (editSupplier) {
      if (editSupplier.id === this.currentDeal.purchaserId) {
        let primaryContact = editSupplier.contacts.find((x) => x.status === 'Active' && x.isPrimary)
        this.currentDeal.purchaserContactName = primaryContact.firstName + ' ' + primaryContact.lastName
        this.currentDeal.purchaserContactEmail = primaryContact.email
        this.currentDeal.purchaserContactMobile = primaryContact.mobile
      }
      this.updateIdentityVerificationModalState(true)
      this.editSupplierId = 0
      this.editSupplierActive = false
      this.isIdentityVerification = true
    },
    onSupplierCancelled: function () {
      this.editSupplierId = 0
      this.editSupplierActive = false
      this.isIdentityVerification = true
    },
    onEditSupplier: function (recipientId) {
      this.editSupplierId = recipientId
      this.editSupplierActive = true
      this.isIdentityVerification = false
    }
  },
  mounted: function () {
  }
}

</script>

<style scoped>
  .columns {
    padding-bottom: 0 !important;
    margin-bottom:0 !important;
  }

  .verification-container {
    margin-bottom: 3em;
  }

  .status-container {
    margin-bottom: 3em;
  }

</style>
